export const ProjectSubscriptionOptions: string[] = ['End of the Year CETA', 'CETA Assigned', 'Focus Students']
export const RCNSubscriptionOptions: string[] = ['End of the Year CETA', 'CETA Assigned', 'Focus Students']
export const ISDSubscriptionOptions: string[] = ['End of the Year CETA', 'CETA Assigned', 'Focus Students']
export const DistrictSubscriptionOptions: string[] = ['End of the Year CETA', 'CETA Assigned', 'Focus Students']
